export default "__VITE_ASSET__BvWGCuIs__"